// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindDynamicString } from "../schema";

export function serialize_KindDynamicString_internal(value: KindDynamicString): unknown {
  return ((value: "dynamicString"): unknown => {
    return value;
  })(value);
}
export function serialize_KindDynamicString(obj: KindDynamicString): string {
  return renderJsonWithNumbersAsBigint(serialize_KindDynamicString_internal(obj));
}
export function deserialize_KindDynamicString_internal(value: unknown): ParserResult<KindDynamicString> {
  return ((value: unknown): ParserResult<"dynamicString"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/KindDynamicString]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "dynamicString":
        return { success: true, value: "dynamicString" };
      default:
        return { success: false, reason: `[#/components/schemas/KindDynamicString]: '${value}' expected to be enum, one of 'dynamicString'.` };
    }
  })(value);
}
export function deserialize_KindDynamicString(str: string): ParserResult<KindDynamicString> {
  return deserialize_KindDynamicString_internal(parseJsonWithNumbersAsBigint(str));
}
